/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e=2216,o=4096;function r(r){return e+o*r.symbolLayers.length+r.complexity.memory.resourceBytes}export{r as getSymbolMemorySize};
